import React from 'react';
import { Mail, Phone, MapPin, Clock, Send } from 'lucide-react';

const ContactoPage = () => {
  return (
    <>
      {/* Header */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-[#1A365D] to-[#2A4A7F] text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Contacto</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Estamos listos para ayudarte a transformar tus datos en resultados de negocio tangibles
          </p>
        </div>
      </section>

      {/* Contact Info & Form */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h2 className="text-2xl font-bold text-[#1A365D] mb-6">Información de Contacto</h2>
              <div className="space-y-6">
                <div className="flex items-start">
                  <Mail className="h-6 w-6 text-[#4A90E2] mr-4 mt-1" />
                  <div>
                    <h3 className="font-semibold text-[#1A365D]">Email</h3>
                    <p className="text-gray-600">contacto@perspectivadata.mx</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <Phone className="h-6 w-6 text-[#4A90E2] mr-4 mt-1" />
                  <div>
                    <h3 className="font-semibold text-[#1A365D]">Teléfono</h3>
                    <p className="text-gray-600">+52 (55) 1234-5678</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <MapPin className="h-6 w-6 text-[#4A90E2] mr-4 mt-1" />
                  <div>
                    <h3 className="font-semibold text-[#1A365D]">Ubicación</h3>
                    <p className="text-gray-600">Ciudad de México, México</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <Clock className="h-6 w-6 text-[#4A90E2] mr-4 mt-1" />
                  <div>
                    <h3 className="font-semibold text-[#1A365D]">Horario</h3>
                    <p className="text-gray-600">Lunes a Viernes: 9:00 AM - 6:00 PM</p>
                  </div>
                </div>
              </div>

              <div className="mt-12">
                <h2 className="text-2xl font-bold text-[#1A365D] mb-6">Agenda una Sesión</h2>
                <p className="text-gray-600 mb-6">
                  La forma más rápida de comenzar es agendar una sesión de diagnóstico gratuita de 30 minutos.
                </p>
                <a 
                  href="https://calendly.com/your-calendly-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#27AE60] text-white px-6 py-3 rounded-md hover:bg-[#219653] transition-colors inline-block"
                >
                  Agendar en Calendly
                </a>
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#1A365D] mb-6">Envíanos un Mensaje</h2>
              <form className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                    Nombre
                  </label>
                  <input
                    type="text"
                    id="name"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#4A90E2]"
                    placeholder="Tu nombre"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#4A90E2]"
                    placeholder="Tu email"
                  />
                </div>
                <div>
                  <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1">
                    Empresa
                  </label>
                  <input
                    type="text"
                    id="company"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#4A90E2]"
                    placeholder="Nombre de tu empresa"
                  />
                </div>
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                    Mensaje
                  </label>
                  <textarea
                    id="message"
                    rows={5}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#4A90E2]"
                    placeholder="¿Cómo podemos ayudarte?"
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="bg-[#1A365D] text-white px-6 py-3 rounded-md hover:bg-[#2A4A7F] transition-colors flex items-center"
                >
                  <Send className="mr-2 h-5 w-5" />
                  Enviar Mensaje
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-[#1A365D] mb-12">Preguntas Frecuentes</h2>
          <div className="max-w-3xl mx-auto space-y-6">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-[#1A365D] mb-3">¿Qué tipo de empresas pueden beneficiarse de sus servicios?</h3>
              <p className="text-gray-600">
                Trabajamos principalmente con empresas medianas y grandes en México que ya tienen datos pero no están obteniendo el valor esperado de ellos. Nuestro enfoque es especialmente valioso para sectores como retail, finanzas, manufactura y servicios.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-[#1A365D] mb-3">¿Cuánto tiempo toma implementar una estrategia de datos?</h3>
              <p className="text-gray-600">
                Depende del alcance y complejidad, pero típicamente comenzamos con un diagnóstico de 2-3 semanas, seguido de implementaciones incrementales que muestran resultados en ciclos de 4-6 semanas. Nuestro enfoque prioriza generar valor rápidamente.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-[#1A365D] mb-3">¿Necesito tener un equipo técnico para trabajar con ustedes?</h3>
              <p className="text-gray-600">
                No es necesario. Podemos trabajar con equipos de todos los niveles de madurez técnica. Parte de nuestro servicio incluye ayudarte a entender qué capacidades necesitas desarrollar internamente y cuáles puedes externalizar.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactoPage;